import React from 'react'
import config from '../config.json'
import checkForAttributeMapping from '../functions/checkForAttributeMapping'
import sortAlphabetical from '../functions/sortAlphabetical'
import AttributeIcon from '../General/AttributIcon'
import SeatClassesIcon from '../General/SeatClassesIcon'
import ItemAttributesContainer from '../PosterFormatItem/ItemAttributesContainer'

const MovieTimesPeriodeDaysItemAttributes = ({
    attributes, 
    hideTheatres, 
    hideAttributes, 
    seatClasses,
    showSeatClassesArray,
    theatreName=false, 
    cinemaName=false,
    bluePricesClass=''
}) => {

    if (cinemaName){
        theatreName = cinemaName + " - " + theatreName
    }

    let allSeatClasses = null
    let visibleSeatClasses = []
    let attributesSorted = attributes ? sortAlphabetical(attributes) : null
    
    if(showSeatClassesArray && !_.isEmpty(seatClasses)) {
        seatClasses.map(seatClass => {
            const {id} = seatClass

            if(_.contains(showSeatClassesArray, id)) {
                visibleSeatClasses.push(seatClass)
            }
        })
    }
    
    if(visibleSeatClasses.length !== 0) {
        let attributesSorted = sortAlphabetical(visibleSeatClasses)
        allSeatClasses = attributesSorted.map((seatClass, index) => {
            const name = seatClass.name
            const id = String(seatClass.id)
            const logoClass = _.contains(config.seatClassesWithIcons, id) ? 'attribute-logo seat-class-logo' : 'seat-class-name'
            const doNotDisplayTitle = _.contains(config.seatClassesWithIcons, id) ? 'screen-reader-text' : ''

            return (
                <span className={id + ' ' + logoClass + ' '} data-attribute={id} key={index}>
                    <SeatClassesIcon attributeId={id}/>
                    <span className={doNotDisplayTitle + ' ' + 'text-medium'}>{name}</span>
                </span>
            )
        })
    }

    return (
        <div className={"performance-attributes theme-radius-posters-bottom" + bluePricesClass}>
            {(!hideTheatres || hideTheatres === 'false') && <span className="text-light-grey theatre-name">{theatreName}</span>}
            {allSeatClasses && allSeatClasses}
            {attributesSorted && !hideAttributes && <ItemAttributesContainer attributes={attributesSorted} canBeColored={true} performanceAttribute={true}/>}
        </div>
    )             
}

export default MovieTimesPeriodeDaysItemAttributes